import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, Tab } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AssessmentTabContent from "./assessment/AssessmentTabContent";
import HistoryTabView from "./history/HistoryTabView";
import SidebarResizeHandle from "../../shared/SidebarResizeHandle";

import styles from "./sideMenu.module.css";

function SideMenu({
  open,
  handleToggle,
  mapRef,
  setMarkerInfo,
  formValues,
  setFormValues,
  activeTab,
  setActiveTab,
  setHistoryAssessmentsForMap,
  selectedEarthquakeLayers,
  width,
  onResize,
}) {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.container} ${open ? "" : styles.hidden}`}
      style={{ width }}
    >
      <SidebarResizeHandle onResize={onResize} />

      <IconButton onClick={handleToggle} className={styles.toggleButton}>
        {open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </IconButton>

      <div className={styles.content}>
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          variant="fullWidth"
          sx={{ mb: 2 }}
        >
          <Tab
            label={t("risksMap.assessmentTab")}
            value="assessment"
          />
          <Tab label={t("risksMap.historyTab")} value="history" />
        </Tabs>

        {activeTab === "assessment" ? (
          <AssessmentTabContent
            mapRef={mapRef}
            setMarkerInfo={setMarkerInfo}
            formValues={formValues}
            setFormValues={setFormValues}
            selectedEarthquakeLayers={selectedEarthquakeLayers}
          />
        ) : (
          <HistoryTabView
            mapRef={mapRef}
            setMarkerInfo={setMarkerInfo}
            active={activeTab === "history"}
            setHistoryAssessmentsForMap={setHistoryAssessmentsForMap}
            selectedEarthquakeLayers={selectedEarthquakeLayers}
          />
        )}
      </div>
    </div>
  );
}

export default SideMenu;
